import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { representativeService } from 'shared/services/representativesService';

const { getRepresentativesResume } = representativeService();

export const useEditProfileMediaResumeData = () => {
  const { id } = useParams() as { id: string };
  const { data, isLoading, isError, refetch, isFetching } = getRepresentativesResume(id);

  const attachedResume = useMemo(() => {
    const categories = data?.data?.profile?.talent?.resume?.categories || [];
    const includedIds = data?.data?.profile?.resume_category_ids || [];

    return includedIds
      .map((id) => categories.find((category) => category.category_id === id && category?.credits?.length > 0))
      .filter((category) => category !== undefined);
  }, [data?.data?.profile?.talent?.resume?.categories, data?.data?.profile?.resume_category_ids]);

  const hiddenResume = useMemo(() => {
    const categories = data?.data?.profile?.talent?.resume?.categories || [];
    const includedIds = data?.data?.profile?.resume_category_ids || [];

    return categories.filter(
      (category) => !includedIds.includes(category.category_id) || category?.credits?.length === 0,
    );
  }, [data?.data?.profile?.talent?.resume?.categories, data?.data?.profile?.resume_category_ids]);

  const creditsLength = useMemo(() => {
    return attachedResume.reduce((accumulator, resume) => {
      return accumulator + (resume?.credits?.length ?? 0);
    }, 0);
  }, [attachedResume?.length]);

  const resumeLoading = isLoading || (isFetching && !data);

  return { id, attachedResume, hiddenResume, creditsLength, resumeLoading, isError, refetch };
};
